import { useCompetitorUpdatesSubscriptionStatusQuery } from "app/pages/activation/queries/settings/useCompetitorUpdatesSubscriptionStatusQuery";
import { useSubscribeToCompetitorUpdatesMutation } from "app/pages/activation/queries/settings/useSubscribeToCompetitorUpdatesMutation";
import { useUnsubscribeFromCompetitorUpdatesMutation } from "app/pages/activation/queries/settings/useUnsubscribeFromCompetitorUpdatesMutation";

export const useNewsAlertsSubscription = (activationSetId: string, isNewsAlertsAvailable: boolean) => {
    const { data: subscriptionStatus, isLoading: isLoadingNewsAlertsStatus } =
        useCompetitorUpdatesSubscriptionStatusQuery({ activationSetId, isNewsAlertsAvailable });
    const { mutate: subscribe, isPending: isNewsAlertsSubscribing } = useSubscribeToCompetitorUpdatesMutation({
        activationSetId,
        isSubscribed: !!subscriptionStatus,
    });
    const { mutate: unsubscribe, isPending: isNewsAlertsUnsubscribing } = useUnsubscribeFromCompetitorUpdatesMutation({
        activationSetId,
    });

    return {
        newsAlertsSubscribe: subscribe,
        newsAlertsUnsubscribe: unsubscribe,
        newsAlertsStatus: subscriptionStatus,
        isNewsAlertsSubscribing,
        isNewsAlertsUnsubscribing,
        isLoadingNewsAlertsStatus,
    };
};
